import { Chip } from '@mui/material';
import { CheckCircle as CheckCircleIcon } from '@mui/icons-material';

function VerifiedBadge({ label = 'Verified' }) {
  return (
    <Chip
      icon={<CheckCircleIcon sx={{ fontSize: '16px !important' }} />}
      label={label}
      size="small"
      sx={{
        bgcolor: 'rgba(46, 125, 50, 0.1)',
        color: 'success.dark',
        fontWeight: 700,
        '& .MuiChip-icon': { color: 'success.main' },
      }}
    />
  );
}

export default VerifiedBadge;
